// extracted by mini-css-extract-plugin
module.exports = {"container":"_aLVkp6Iq","avatar":"_rX-abKfc","textContent":"_RIIxAhay","text":"_3GgzirCM"};